import { createApp } from 'vue'
import { createHead } from '@vueuse/head'
import App from './App.vue'
import router from './router'
import store from './store'
import { auth } from './firebase'
import './assets/css/main.css'
import '@fortawesome/fontawesome-free/css/all.css'

const head = createHead()

let app

auth.onAuthStateChanged((user) => {
  if (!app) {
    app = createApp(App)

    app.use(store)
    app.use(router)
    app.use(head)

    app.mount('#app')
  }

  if (user && user.email === 'sqwervmusic@gmail.com') {
    store.commit('LOGIN_USER')
  } else if (!user) {
    // handle logout
    store.commit('LOGOUT_USER')
  }
})
